/** @format */
import angular from 'angular';
import { TooltipComponent } from '../tooltip/tooltip.component';
import curriculumPeriodsTpl from './curriculumPeriods.tpl.html';

export const curriculumPeriodsModule = 'sis-components.curriculumPeriod.curriculumPeriods';

angular.module(curriculumPeriodsModule, [TooltipComponent.downgrade.moduleName]).component('curriculumPeriods', {
    bindings: {
        courseUnit: '=',
    },
    template: curriculumPeriodsTpl,
});
